import { Ng2StateDeclaration } from '@uirouter/angular';
import { AppearanceModuleSideListOptions } from '@fi-app/appearance/module-side-list-options';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ModuleType } from '@fi-shared/types';
import { IAppearanceSidebarStateModel } from '@fi-app/appearance/appearance';

export const FiAppearanceListViewState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.ListView._name,
    url: '/ListView',
    abstract: true,
    component: FiAbstractStateComponent,
    resolve: {
        appearanceSidebarStateModel: [FiAppearanceListViewStateResolveModel],
    },
};

export function FiAppearanceListViewStateResolveModel(): IAppearanceSidebarStateModel {
    return {
        modulePreviewTemplateName: AppearanceModuleSideListOptions.find(
            (item) => item.moduleType !== ModuleType.Document,
        ).previewTemplateName,
    };
}
